module.exports = __webpack_public_path__ + "img/feedback_danger.a8458c66.svg";